module.exports = __webpack_public_path__ + "img/ic_home_totok_ar.558ea80f.png";